import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';
import LoginButton from '../components/LoginButton.tsx';
import { useTranslation } from 'react-i18next';

const LoginPage: React.FC = () => {
  const { user, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        {t('loginPage.loading')}
      </div>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-[#f7a600] to-[#ffbe33] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-md shadow-xl">
        <div>
          <h2 className="mt-6 text-center text-4xl font-bold text-gray-900">
            PergolaMaster - {t('loginPage.title')}
          </h2>
        </div>
        <div className="mt-8 space-y-6">
          <div className="flex justify-center">
            <LoginButton className="hover:opacity-80 transition-opacity" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;